import React, { useContext, useEffect, useState } from 'react';
import { Box, IconButton, Avatar, Button, Typography, Grid } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ImgUploadDialog from '../../../components/ImgUpload/imgUpload';
import { Helpers } from '../../../services/Helpers';
import panImageDefault from '../../../assets/images/pan_defult.png'
import { UserProfileContext } from '../UserProfile';
import { Controller, useFormContext } from 'react-hook-form';
import Swal from 'sweetalert2';
import { RemoveRedEye } from '@mui/icons-material';

const PanImageUpload = ({ allowVerificationOverride }) => {
    const { businessDetailsData, setBusinessDetailsData } = useContext(UserProfileContext);
    const { control, setValue, watch } = useFormContext();

    const panNumber = watch('panNumber');
    const panImage = watch('panImage');
    const isPanVerified = allowVerificationOverride && Boolean(watch('isPanVerified'));

    const [trigStatus, setTrigStatus] = useState(null);
    const [imgModalOpen, setImgModalOpen] = useState(false);


    const closeModal = () => {
        setImgModalOpen(false);
    };

    const imgData = {
        path: "profile",
        // path: "kyc",
        // image_name: `img-${GenerateUniqueVal(1000000)}-${personalDetails.id}.jpeg`,
        img_type: "single"
    };


    const handleImageUpload = (uploadedImageData) => {
        console.log(uploadedImageData)
        // Set the uploaded PAN image URL to the form
        setValue('panImage', uploadedImageData.imageName, {
            shouldValidate: true,
            shouldDirty: true
        });
        closeModal();
    };
    const viewImage = (image) => {
        // using swal to view image...not close on outside click
        Swal.fire({
            html: `<div style="text-align:left;font-size: 0.9rem; font-weight: 500; color: #333;">${image}</div><img src="${Helpers.ImagePathUrl()}/profile/lg/${image}" alt="PAN Image" style="width:100%;height:auto;margin-top:1rem"/>`,
            showCloseButton: true,
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });
    }

    useEffect(() => {
        // setProfileImage('')
    }, [])
    return (
        <Grid item xs={12} sm={7} sx={{ mt: { sm: '3.25%' } }} order={{ xs: 3, sm: 2 }}>
            <ImgUploadDialog
                open={imgModalOpen}
                onClose={closeModal}
                imgData={imgData}
                imgUploadResponse={(data) => handleImageUpload(data)}
                keepOriginal={true}
            // trigStatus={handlePImgTrig}
            />

            <Controller
                name="panImage"
                control={control}
                rules={{
                    validate: (value) => {
                        if (panNumber && !isPanVerified && !value) {
                            return "PAN image is required when PAN number is provided";
                        }
                        return true;
                    },
                }}
                
                render={({ fieldState: { error } }) => (
                    <Box sx={{ display: 'flex', gap: '3%' }}>
                        <Box sx={{ display: `${!panNumber ? 'none' : 'flex'}`, height: '100%', alignItems: 'start', alignSelf: 'flex-end', flexDirection: 'column' }}>
                            <Button
                                sx={{ width: 'max-content', textTransform: 'none' }}
                                variant="contained"
                                size='small'
                                onClick={() => setImgModalOpen(true)}
                            >
                                {(panImage || businessDetailsData.panImage) ? 'Update PAN Card' : 'Upload PAN Card'}
                            </Button>
                            {error && (
                                <Typography color="error" sx={{ mt: 1, textAlign: 'center', fontSize: '.5rem' }}>
                                    {error.message}
                                </Typography>
                            )}
                        </Box>
                        {(panImage || businessDetailsData.panImage) &&
                            <>
                                <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue', display: { xs: 'block', md: 'none' } }} onClick={() => viewImage(panImage || businessDetailsData.panImage)}>
                                    <RemoveRedEye />
                                </Typography>
                                <Typography sx={{ cursor: 'pointer', fontSize: '.75rem', color: 'blue', display: { xs: 'none', md: 'block' } }} onClick={() => viewImage(panImage || businessDetailsData.panImage)}>
                                    View PAN
                                </Typography>
                            </>
                        }
                    </Box>
                )}
            />
        </Grid>
    );
}

export default PanImageUpload;
